import { theme } from '../../styles/theme';
import { buttonDark, buttonPrimary } from '../../styles/button';
export const setPasswordContainer = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
};
export const setPasswordParagraph = {
    fontSize: '16px',
    textAlign: 'center',
    color: theme.palette.common.darkGrey2,
    marginTop: '24px'
};
export const setPasswordFormStack = { paddingBottom: 0, marginTop: '24px' };
export const setPasswordHeader = {
    fontSize: '22px',
    fontWeight: 800,
    color: theme.palette.common.darkGrey1,
    textAlign: 'center'
};
export const setPasswordHintsContainer = {
    width: '100%',
    maxWidth: '370px',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '5px'
};
export const setPasswordCounter = {
    width: '150px',
    fontSize: '12px',
    textAlign: 'right'
};
export const setPasswordTextFieldContainer = {
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: '20px',
    marginTop: '30px'
};
export const setPasswordButton = {
    ...buttonPrimary,
    marginY: '30px',
    minWidth: '248px'
};
export const setPasswordLink = {
    fontWeight: 700,
    textDecoration: 'underline',
    cursor: 'pointer'
};
export const setPasswordSuccessHeader = {
    fontSize: '22px',
    fontWeight: 800,
    color: theme.palette.common.darkGrey1,
    textAlign: 'center',
    marginTop: '20px'
};
export const setPasswordSuccessParagraph = {
    fontSize: '16px',
    textAlign: 'center',
    color: theme.palette.common.darkGrey2,
    marginTop: '24px',
    paddingLeft: '20px',
    paddingRight: '20px'
};
export const setPasswordLoginButton = {
    ...buttonDark,
    marginTop: '24px',
    minWidth: '248px'
};
export const setPasswordLength = (valid) => ({
    position: 'absolute',
    right: '0',
    bottom: '-25px',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: 0,
    color: valid ? theme.palette.common.darkGreen : theme.palette.common.darkGrey2
});
//# sourceMappingURL=SetPassword.styles.js.map